/* bs-cart-drawer — Carrito lateral. Custom element <bs-cart-drawer>.

   - Se abre al pulsar el botón de carrito del header (.bs-header__cart) o cualquier
     [data-bs-cart-open]; cierra con X, overlay, ESC. Focus trap + restore.
   - Mutaciones (± / eliminar / borrar todo) vía POST /cart/change.js con Section
     Rendering (sections: 'bs-cart-drawer' + la página de carrito si está presente).
     Sustituye el contenido del panel conservando el estado abierto (clicks por delegación).
   - Dispara 'cart:update' para que el badge del header y demás se sincronicen. */
(function () {
  'use strict';

  class BSCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.__bsInit) return;
      this.__bsInit = true;

      var cfg = {};
      try {
        var el = this.parentNode ? this.parentNode.querySelector('[data-bs-cart-config]') : null;
        if (!el) el = document.querySelector('[data-bs-cart-config]');
        if (el) cfg = JSON.parse(el.textContent);
      } catch (e) {}
      this.changeUrl = cfg.changeUrl || '/cart/change.js';
      this.sectionId = this.getAttribute('data-section-id') || cfg.sectionId || 'bs-cart-drawer';
      this.lastFocus = null;

      // Delegación de clicks internos del panel (sobrevive a re-render).
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));

      // Apertura desde el header / cualquier trigger — a nivel documento, una sola vez.
      if (!window.__bsCartOpenBound) {
        window.__bsCartOpenBound = true;
        document.addEventListener('click', function (e) {
          var trigger = e.target.closest('.bs-header__cart, [data-bs-cart-open]');
          if (!trigger) return;
          var drawer = document.querySelector('bs-cart-drawer');
          if (!drawer) return;
          e.preventDefault();
          drawer.open(trigger);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          var drawer = document.querySelector('bs-cart-drawer');
          if (drawer && drawer.classList.contains('is-open')) drawer.close();
        });

        // Añadir al carrito desde CUALQUIER sitio → abrir + refrescar el drawer al instante.
        // Los add-to-cart del theme (card, carrusel, FBT, relacionados, PDP) disparan
        // 'cart:update' con detail.data.source. Los cambios de cantidad (drawer / página de
        // carrito) NO traen data.source → así solo abrimos al AÑADIR, no al modificar.
        document.addEventListener('cart:update', function (e) {
          var src = e && e.detail && e.detail.data && e.detail.data.source;
          if (!src) return;
          var drawer = document.querySelector('bs-cart-drawer');
          if (!drawer || drawer.__bsSuppressOpen) return;
          drawer.refresh().then(function () { drawer.open(); });
        });

        // Card de colección/búsqueda (bs-product-card): su <form> no tenía JS → hacía POST y
        // recargaba. Lo interceptamos: AJAX /cart/add.js y dejamos que el listener de arriba
        // abra el drawer (dispatch de 'cart:update' con source 'bs-product-card').
        document.addEventListener('submit', function (e) {
          var form = e.target.closest ? e.target.closest('[data-bs-product-card-form]') : null;
          if (!form) return;
          e.preventDefault();
          var drawer = document.querySelector('bs-cart-drawer');
          if (!drawer) { form.submit(); return; }
          drawer.addFromForm(form);
        });
      }
    }

    /* ===== Abrir / cerrar ===== */
    open(trigger) {
      this.lastFocus = trigger || document.activeElement;
      this.classList.add('is-open');
      document.body.classList.add('bs-cart-open');
      var panel = this.querySelector('.bs-cart-drawer__panel');
      if (panel) {
        // foco al primer control accionable del panel
        var focusable = panel.querySelector('.bs-cart-drawer__close');
        if (focusable) window.requestAnimationFrame(function () { focusable.focus(); });
      }
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('bs-cart-open');
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    /* ===== Focus trap dentro del panel ===== */
    onKeydown(e) {
      if (e.key !== 'Tab' || !this.classList.contains('is-open')) return;
      var panel = this.querySelector('.bs-cart-drawer__panel');
      if (!panel) return;
      var items = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ===== Delegación de clicks ===== */
    onClick(e) {
      var t = e.target;
      if (t.closest('[data-bs-cart-close]') || t.closest('.bs-cart-drawer__overlay')) {
        e.preventDefault(); this.close(); return;
      }
      var item = t.closest('.bs-cart-drawer__item');
      if (t.closest('[data-bs-cart-minus]') && item) { e.preventDefault(); this.step(item, -1); return; }
      if (t.closest('[data-bs-cart-plus]') && item) { e.preventDefault(); this.step(item, 1); return; }
      if (t.closest('[data-bs-cart-remove]') && item) { e.preventDefault(); this.setQty(item.getAttribute('data-key'), 0); return; }
      if (t.closest('[data-bs-cart-clear]')) { e.preventDefault(); this.clearAll(); return; }
      if (t.closest('[data-bs-cart-promo-apply]')) { e.preventDefault(); this.applyPromo(); return; }
    }

    step(item, dir) {
      var qtyEl = item.querySelector('[data-bs-cart-qty]');
      var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      var min = parseInt(item.getAttribute('data-min'), 10) || 1;
      var stepN = parseInt(item.getAttribute('data-step'), 10) || 1;
      var max = item.getAttribute('data-max') ? parseInt(item.getAttribute('data-max'), 10) : null;
      var next = current + dir * stepN;
      if (next < min) next = dir < 0 ? 0 : min; // por debajo del mínimo al restar = eliminar
      if (max && next > max) next = max;
      this.setQty(item.getAttribute('data-key'), next);
    }

    clearAll() {
      var items = this.querySelectorAll('.bs-cart-drawer__item');
      if (!items.length) return;
      // /cart/update.js con todas las cantidades a 0 (soporta Section Rendering).
      var zeros = Array.prototype.map.call(items, function () { return 0; });
      this.mutate('/cart/update.js', { updates: zeros });
    }

    setQty(key, qty) {
      if (!key) return;
      this.mutate(this.changeUrl, { id: key, quantity: qty });
    }

    applyPromo() {
      var input = this.querySelector('[data-bs-cart-promo-input]');
      var code = input ? input.value.trim() : '';
      if (!code) { if (input) input.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(window.location.pathname);
    }

    /* ===== AJAX + Section Rendering ===== */
    sectionsToRender() {
      var ids = [this.sectionId];
      var mainCart = document.querySelector('[data-bs-main-cart]');
      if (mainCart && mainCart.getAttribute('data-section-id')) {
        ids.push(mainCart.getAttribute('data-section-id'));
      }
      return ids;
    }

    mutate(url, body) {
      var self = this;
      this.classList.add('is-loading');
      var sections = this.sectionsToRender();
      var payload = Object.assign({}, body || {}, {
        sections: sections.join(','),
        sections_url: window.location.pathname
      });
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.sections) self.applySections(cart.sections);
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { self.classList.remove('is-loading'); });
    }

    applySections(sections) {
      // Drawer: sustituir el interior del panel conservando el estado abierto.
      var drawerHtml = sections[this.sectionId];
      if (drawerHtml) {
        var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var newPanel = doc.querySelector('.bs-cart-drawer__panel');
        var curPanel = this.querySelector('.bs-cart-drawer__panel');
        if (newPanel && curPanel) curPanel.innerHTML = newPanel.innerHTML;
      }
      // Página de carrito (si está presente): dejar que se actualice sola.
      var mainCart = document.querySelector('[data-bs-main-cart]');
      if (mainCart) {
        var mcId = mainCart.getAttribute('data-section-id');
        if (mcId && sections[mcId]) {
          var mdoc = new DOMParser().parseFromString(sections[mcId], 'text/html');
          var newMc = mdoc.querySelector('[data-bs-main-cart]');
          if (newMc) mainCart.innerHTML = newMc.innerHTML;
        }
      }
    }

    /* Re-render del drawer con el carrito actual. Usa la Cart AJAX API (/cart/update.js sin
       cambios) porque renderiza secciones globales del layout — la Section Rendering API por
       GET (?sections=) NO renderiza el drawer, que vive en theme.liquid. */
    refresh() {
      var self = this;
      this.classList.add('is-loading');
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          sections: this.sectionsToRender().join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.sections) self.applySections(cart.sections); })
        .catch(function () {})
        .finally(function () { self.classList.remove('is-loading'); });
    }

    /* Add-to-cart de un <form> de card: AJAX /cart/add.js + dispatch 'cart:update'
       (el listener global abre + refresca el drawer). Fallback a POST nativo si falla la red. */
    addFromForm(form) {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      var restore = function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok || (res.body && res.body.status)) {
            // Error (agotado, regla de cantidad B2B, etc.): avisar y no abrir.
            document.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { data: res.body } }));
            restore();
            return;
          }
          restore();
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: null, data: { source: 'bs-product-card' } }
          }));
        })
        .catch(function () { restore(); form.submit(); });
    }
  }

  if (!customElements.get('bs-cart-drawer')) {
    customElements.define('bs-cart-drawer', BSCartDrawer);
  }
})();
